import WiseView from '../../WiseView.vue';
import { frontendURL } from '../../../../../helper/URLHelper';
import IntegrationsWise from './IntegrationsWise.vue';
export const routes = [
  {
    path: frontendURL('accounts/:accountId/wise/integrations-wise'),
    name: 'wise',
    roles: ['administrator'],
    component: WiseView,
    children: [
      {
        path: '',
        name: 'integrations_wise',
        component: IntegrationsWise,
        roles: ['administrator'],
      },
    ],
  },
];
